import bassImg from "../assets/pan-bass-w.jpg";
import tenorImg from "../assets/pan-tenor-c.png";
import celloImg from "../assets/pan-cello-w.jpg";

export function HomeStageBackdrop() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-black" style={{ filter: "brightness(0.25)", transform: "scale(1.02)" }}>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,oklch(0.18_0.01_250)_0%,oklch(0.1_0.005_250)_60%,oklch(0.08_0.005_250)_100%)]" />
      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/60 to-transparent" />
      <div className="absolute inset-0 bg-black" />

      <div className="absolute left-[38%] top-[36%] h-[240px] w-[240px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-full shadow-[0_28px_60px_-10px_rgba(0,0,0,0.7)] md:h-[480px] md:w-[480px]">
        <img src={celloImg} alt="" className="h-full w-full rounded-full object-cover opacity-90 shadow-[inset_0_6px_22px_rgba(0,0,0,.55),inset_0_-10px_30px_rgba(0,0,0,.45),0_28px_60px_-10px_rgba(0,0,0,.7),0_0_0_1px_rgba(255,255,255,.04)]" />
      </div>

      <div className="absolute left-[60%] top-[42%] h-[240px] w-[240px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-full shadow-[0_28px_60px_-10px_rgba(0,0,0,0.7)] md:h-[480px] md:w-[480px]">
        <img src={tenorImg} alt="" className="h-full w-full rounded-full object-cover opacity-90 shadow-[inset_0_6px_22px_rgba(0,0,0,.55),inset_0_-10px_30px_rgba(0,0,0,.45),0_28px_60px_-10px_rgba(0,0,0,.7),0_0_0_1px_rgba(255,255,255,.04)]" />
      </div>

      <div className="absolute left-[50%] top-[68%] h-[240px] w-[240px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-full shadow-[0_28px_60px_-10px_rgba(0,0,0,0.7)] md:h-[480px] md:w-[480px]">
        <img src={bassImg} alt="" className="h-full w-full rounded-full object-cover opacity-90 shadow-[inset_0_6px_22px_rgba(0,0,0,.55),inset_0_-10px_30px_rgba(0,0,0,.45),0_28px_60px_-10px_rgba(0,0,0,.7),0_0_0_1px_rgba(255,255,255,.04)]" />
      </div>

    </div>
  );
}
